import { render, staticRenderFns } from "./TongueDiagnosis.vue?vue&type=template&id=4f9976ce&scoped=true"
import script from "./TongueDiagnosis.vue?vue&type=script&lang=js"
export * from "./TongueDiagnosis.vue?vue&type=script&lang=js"
import style0 from "./TongueDiagnosis.vue?vue&type=style&index=0&id=4f9976ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f9976ce",
  null
  
)

export default component.exports